import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux'

import { SHOW_PAIR_OPTION } from 'Component/AddToCartPopUp/AddToCartPopUp.config';
import Button from 'Component/Button';
import { SIZE_NONE, TEXT_SIZE_SMALL, TYPE_TEXT, WIDTH_HUG } from 'Component/Button/Button.config';
import { ProductType } from 'Type/ProductList.type';

import { ANIMATION_CLASS } from './PurchasePairs.config'

/** @namespace Bodypwa/Component/PurchasePairs/Component/PurchasePairsComponent */
export const PurchasePairsComponent = (props) => {
    const {
        quantity,
        onMakePair,
        isProductInCart,
        product
    } = props;

    const purchasePairs = useSelector((state) => state.ConfigReducer.purchase_pairs);

    const isVisible = quantity === 1 && !isProductInCart;
    const { attributes = {} } = product || {};
    const showPairOption = attributes[SHOW_PAIR_OPTION]?.attribute_value === '1';

    const handleClick = useCallback(() => {
        onMakePair();

        const qtyInput = document.getElementById('item_qty');
        if (qtyInput) {
            qtyInput.classList.add(ANIMATION_CLASS);
            qtyInput.addEventListener(
                'animationend',
                () => qtyInput.classList.remove(ANIMATION_CLASS),
                { once: true }
            );
        }
    }, [onMakePair]);

    if( !showPairOption || !purchasePairs ) {
        return null
    }

    return (
        <div className={ `relative flex justify-between items-center bg-bmBg-muted px-4 py-5 mb-6
                transition-opacity duration-500 ease-in-out
                ${ isVisible ? 'opacity-100' : 'lg:opacity-0 lg:pointer-events-none lg:flex hidden' }` }
        >
            <p className="text-p14">{ __('Sold as a single item') }</p>
            <Button
                id="purchase_pairs"
                className="underline font-bold"
                textSize={ TEXT_SIZE_SMALL }
                type={ TYPE_TEXT }
                width={ WIDTH_HUG }
                size={ SIZE_NONE }
                text={ __('Make it a pair') }
                onClick={ handleClick }
            />
        </div>
    );
};

PurchasePairsComponent.propTypes = {
    quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.object]).isRequired,
    onMakePair: PropTypes.func.isRequired,
    isProductInCart: PropTypes.bool.isRequired,
    product: ProductType.isRequired
};

export default PurchasePairsComponent;